module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$props.to) ? _c('router-link', {
    class: _vm.classes,
    attrs: {
      "to": _vm.$props.to
    }
  }, [_c('z-icon', {
    attrs: {
      "icon": _vm.$props.icon
    }
  })], 1) : _c('div', {
    class: _vm.classes,
    on: {
      "click": _vm.onClick
    }
  }, [_c('z-icon', {
    attrs: {
      "icon": _vm.$props.icon
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2315c95a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZIconButton.vue
// module id = 1068
// module chunks = 0